interface Props {
  className?: string
}
export const ArrowRight = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={7}
      height={12}
      viewBox='0 0 7 12'
      fill='none'
    >
      <path
        d='M0.2925 0.310364C-0.0975 0.700364 -0.0975 1.33036 0.2925 1.72036L4.1725 5.60036L0.2925 9.48036C-0.0975 9.87036 -0.0975 10.5004 0.2925 10.8904C0.6825 11.2804 1.3125 11.2804 1.7025 10.8904L6.2925 6.30036C6.6825 5.91036 6.6825 5.28036 6.2925 4.89036L1.7025 0.300364C1.3225 -0.0796364 0.6825 -0.0796361 0.2925 0.310364Z'
        fill='#919499'
      />
    </svg>
  )
}
export const Location = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12 0C7.11133 0 3.13428 3.97705 3.13428 8.86571C3.13428 10.4751 3.85605 12.206 3.8863 12.279C4.11941 12.8323 4.57939 13.6918 4.91107 14.1956L10.9898 23.406C11.2386 23.7836 11.6068 24 12 24C12.3932 24 12.7614 23.7836 13.0102 23.4065L19.0894 14.1956C19.4216 13.6918 19.8811 12.8323 20.1142 12.279C20.1444 12.2065 20.8657 10.4756 20.8657 8.86571C20.8657 3.97705 16.8886 0 12 0ZM19.1525 11.8743C18.9444 12.3703 18.5163 13.1698 18.2185 13.6214L12.1392 22.8323C12.0193 23.0143 11.9812 23.0143 11.8613 22.8323L5.782 13.6214C5.48421 13.1698 5.05605 12.3698 4.84797 11.8738C4.8391 11.8524 4.1773 10.2592 4.1773 8.86571C4.1773 4.55228 7.68656 1.04302 12 1.04302C16.3134 1.04302 19.8227 4.55228 19.8227 8.86571C19.8227 10.2613 19.1593 11.8587 19.1525 11.8743Z'
        fill='black'
      />
      <path
        d='M12 4.17261C9.41174 4.17261 7.3064 6.27847 7.3064 8.86622C7.3064 11.454 9.41174 13.5598 12 13.5598C14.5883 13.5598 16.6936 11.454 16.6936 8.86622C16.6936 6.27847 14.5883 4.17261 12 4.17261ZM12 12.5168C9.98749 12.5168 8.34942 10.8793 8.34942 8.86622C8.34942 6.85318 9.98749 5.21563 12 5.21563C14.0125 5.21563 15.6506 6.85318 15.6506 8.86622C15.6506 10.8793 14.0125 12.5168 12 12.5168Z'
        fill='black'
      />
    </svg>
  )
}

export const LocationBlack = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      viewBox='0 0 17 17'
      fill='none'
    >
      <g clipPath='url(#clip0_223_12540)'>
        <path
          d='M8.43848 0.184082C6.84783 0.186192 5.32293 0.819011 4.19817 1.94377C3.07341 3.06853 2.44059 4.59343 2.43848 6.18408C2.43848 10.4916 8.02848 15.8866 8.26598 16.1141C8.31217 16.159 8.37406 16.1841 8.43848 16.1841C8.5029 16.1841 8.56478 16.159 8.61098 16.1141C8.84848 15.8866 14.4385 10.4916 14.4385 6.18408C14.4364 4.59343 13.8035 3.06853 12.6788 1.94377C11.554 0.819011 10.0291 0.186192 8.43848 0.184082ZM8.43848 8.93408C7.89458 8.93408 7.36289 8.7728 6.91066 8.47062C6.45842 8.16845 6.10595 7.73896 5.89781 7.23646C5.68967 6.73397 5.63521 6.18103 5.74132 5.64758C5.84743 5.11414 6.10934 4.62413 6.49393 4.23954C6.87853 3.85494 7.36853 3.59303 7.90198 3.48692C8.43543 3.38081 8.98836 3.43527 9.49086 3.64341C9.99335 3.85155 10.4228 4.20403 10.725 4.65626C11.0272 5.1085 11.1885 5.64018 11.1885 6.18408C11.188 6.91329 10.8982 7.61251 10.3825 8.12814C9.86691 8.64377 9.16769 8.93365 8.43848 8.93408Z'
          fill='#4294FE'
        />
      </g>
      <defs>
        <clipPath id='clip0_223_12540'>
          <rect
            width={16}
            height={16}
            fill='white'
            transform='translate(0.438477 0.184082)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconDescription = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <mask
        id='mask0_3726_6735'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={22}
        height={22}
      >
        <path
          d='M0.160156 0.160889H21.8386V21.8394H0.160156V0.160889Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_3726_6735)'>
        <path
          d='M16.6093 13.5059L21.4156 16.0068L10.9998 21.4264L0.583984 16.0068L5.39021 13.506'
          stroke='black'
          strokeWidth='0.8'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <path
        d='M3.1875 12.3553L7.9444 9.88019'
        stroke='black'
        strokeWidth='0.8'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.79102 13.7043L10.5353 11.2358'
        stroke='black'
        strokeWidth='0.8'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.45898 15.0295L18.7478 9.659'
        stroke='black'
        strokeWidth='0.8'
        strokeMiterlimit={10}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <mask
        id='mask1_3726_6735'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={22}
        height={22}
      >
        <path
          d='M0.160156 0.160889H21.8386V21.8394H0.160156V0.160889Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask1_3726_6735)'>
        <path
          d='M16.6369 8.51856L21.4156 11.0051L10.9998 16.4247L0.583984 11.0051L5.39021 8.50429'
          stroke='black'
          strokeWidth='0.8'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M17.8977 4.17337L21.4156 6.00385L10.9998 11.4235L0.583984 6.00385L10.9998 0.584229L14.5176 2.41462'
          stroke='black'
          strokeWidth='0.8'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export const IconSpec = () => {
  return (
    <svg
      width={40}
      height={22}
      viewBox='0 0 40 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M29.3681 13.5929H27.6687C27.5535 13.9338 27.4159 14.2667 27.257 14.5892L28.4589 15.7911C28.9728 16.3053 28.9728 17.1387 28.4589 17.6528L26.6527 19.4578C26.1315 19.9549 25.3121 19.9549 24.791 19.4578L23.589 18.2558C23.2668 18.4154 22.9343 18.553 22.5937 18.6675V20.3686C22.5927 21.0948 22.0041 21.6834 21.2779 21.6841H18.7231C17.9966 21.6837 17.4076 21.0951 17.4066 20.3686V18.6682C17.066 18.5536 16.7335 18.4161 16.4113 18.2565L15.211 19.4585C14.6898 19.9556 13.8705 19.9556 13.3493 19.4585L11.542 17.6522C11.0289 17.1377 11.0289 16.305 11.542 15.7905L12.744 14.5885C12.5851 14.266 12.4475 13.9331 12.3323 13.5922H10.6329C9.9067 13.5919 9.31774 13.0036 9.31641 12.2774V9.72258C9.31741 8.99607 9.90637 8.40744 10.6329 8.40711H12.3323C12.4475 8.06622 12.5851 7.73334 12.744 7.41082L11.542 6.20886C11.0282 5.69469 11.0282 4.86133 11.542 4.34716L13.3476 2.54155C13.8688 2.0444 14.6882 2.0444 15.2093 2.54155L16.4113 3.74351C16.7335 3.58391 17.066 3.44635 17.4066 3.33183V1.6314C17.4076 0.904877 17.9966 0.316252 18.7231 0.315918H21.2779C22.0044 0.316252 22.5934 0.904877 22.5944 1.6314V3.33183C22.9349 3.44635 23.2675 3.58391 23.5897 3.74351L24.79 2.54155C25.3111 2.0444 26.1305 2.0444 26.6517 2.54155L28.4589 4.34716C28.9721 4.86166 28.9721 5.69435 28.4589 6.20886L27.257 7.41082C27.4159 7.73334 27.5535 8.06622 27.6687 8.40711H29.3681C30.0946 8.40744 30.6836 8.99607 30.6846 9.72258V12.2774C30.6836 13.0039 30.0946 13.5926 29.3681 13.5929ZM29.7554 9.72258C29.7547 9.50924 29.5814 9.33629 29.3681 9.33595H27.3278C27.1211 9.33662 26.9391 9.2004 26.8814 9.00208C26.7355 8.49692 26.5338 8.00946 26.2804 7.54871C26.1796 7.36708 26.2113 7.14038 26.3585 6.99347L27.8012 5.55112C27.9524 5.39987 27.9524 5.15447 27.8012 5.00289L25.9939 3.19761C25.8423 3.04871 25.5993 3.04871 25.4477 3.19761L24.007 4.64197C23.8611 4.78921 23.6351 4.82093 23.4545 4.71976C22.9944 4.46635 22.5076 4.26469 22.0028 4.11878C21.8041 4.06136 21.6672 3.87939 21.6669 3.67239V1.6314C21.6662 1.41805 21.4929 1.24543 21.2796 1.2451H18.7231C18.5097 1.24543 18.3364 1.41805 18.3358 1.6314V3.67272C18.3354 3.87973 18.1986 4.06169 17.9999 4.11912C17.4951 4.26502 17.0083 4.46668 16.5482 4.7201C16.4797 4.75883 16.4026 4.77886 16.3242 4.77819C16.201 4.77786 16.0831 4.72911 15.9956 4.6423L14.5523 3.19962C14.4007 3.05071 14.1576 3.05071 14.0061 3.19962L12.2008 5.00456C12.0495 5.15514 12.0489 5.39987 12.1994 5.55145L12.2008 5.55279L13.6425 6.99347C13.7884 7.13971 13.8204 7.36441 13.7213 7.54537C13.4678 8.00612 13.2662 8.49358 13.1203 8.99874C13.0625 9.19706 12.8805 9.33328 12.6739 9.33262H10.6329C10.4195 9.33295 10.2463 9.5059 10.2456 9.71925V12.2774C10.2463 12.4908 10.4195 12.6637 10.6329 12.664H12.6732C12.8799 12.6634 13.0618 12.7996 13.1196 12.9979C13.2655 13.5031 13.4672 13.9905 13.7206 14.4513C13.8197 14.6323 13.7877 14.857 13.6418 15.0032L12.1991 16.4455C12.0479 16.5968 12.0479 16.8422 12.1991 16.9938L14.0064 18.799C14.158 18.948 14.401 18.948 14.5526 18.799L15.995 17.3564C16.1409 17.2095 16.3666 17.1777 16.5475 17.2786C17.0076 17.532 17.4944 17.7336 17.9992 17.8795C18.1979 17.937 18.3348 18.1189 18.3351 18.3259V20.3686C18.3358 20.582 18.5091 20.7546 18.7224 20.7549H21.2772C21.4906 20.7546 21.6639 20.582 21.6645 20.3686V18.3273C21.6649 18.1203 21.8018 17.9383 22.0004 17.8809C22.5052 17.735 22.992 17.5333 23.4521 17.2799C23.6334 17.1774 23.8611 17.2095 24.007 17.358L25.4504 18.8007C25.602 18.9496 25.845 18.9496 25.9966 18.8007L27.8019 16.9954C27.9531 16.8449 27.9538 16.6001 27.8032 16.4485C27.8029 16.4482 27.8022 16.4475 27.8019 16.4472L26.3592 15.0049C26.2133 14.8586 26.1812 14.6339 26.2804 14.453C26.5338 13.9922 26.7355 13.5047 26.8814 12.9996C26.9391 12.8013 27.1211 12.665 27.3278 12.6657H29.3681C29.5814 12.6654 29.7547 12.4924 29.7554 12.2791V9.72258ZM20.0005 14.8703C17.863 14.869 16.1315 13.1348 16.1329 10.9973C16.1342 8.85985 17.8683 7.12836 20.0058 7.12969C22.1423 7.13103 23.8735 8.86352 23.8735 11C23.8708 13.1375 22.138 14.869 20.0005 14.8703ZM20.0005 8.05921C18.3758 8.05954 17.0594 9.37669 17.0597 11.0013C17.06 12.626 18.3772 13.9425 20.0018 13.9421C21.6265 13.9418 22.943 12.6246 22.9426 11C22.9406 9.37602 21.6245 8.05987 20.0005 8.05854V8.05921Z'
        fill='black'
      />
    </svg>
  )
}
export const IconCompared = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.5 6.74994H7.1895L5.46975 8.46969C5.39812 8.53887 5.34098 8.62163 5.30167 8.71314C5.26237 8.80464 5.24168 8.90305 5.24081 9.00264C5.23995 9.10222 5.25892 9.20098 5.29663 9.29315C5.33434 9.38533 5.39003 9.46907 5.46045 9.53948C5.53087 9.6099 5.61461 9.66559 5.70678 9.7033C5.79896 9.74102 5.89772 9.75999 5.9973 9.75913C6.09689 9.75826 6.1953 9.73757 6.2868 9.69827C6.37831 9.65896 6.46106 9.60182 6.53025 9.53019L9.53025 6.53019C9.67085 6.38954 9.74984 6.19881 9.74984 5.99994C9.74984 5.80107 9.67085 5.61033 9.53025 5.46969L6.53025 2.46969C6.46106 2.39806 6.37831 2.34092 6.2868 2.30161C6.1953 2.26231 6.09689 2.24162 5.9973 2.24075C5.89772 2.23989 5.79896 2.25886 5.70678 2.29657C5.61461 2.33428 5.53087 2.38997 5.46045 2.46039C5.39003 2.53081 5.33434 2.61455 5.29663 2.70672C5.25892 2.7989 5.23995 2.89766 5.24081 2.99724C5.24168 3.09682 5.26237 3.19524 5.30167 3.28674C5.34098 3.37825 5.39812 3.461 5.46975 3.53019L7.1895 5.24994H1.5C1.30109 5.24994 1.11032 5.32896 0.96967 5.46961C0.829018 5.61026 0.75 5.80103 0.75 5.99994C0.75 6.19885 0.829018 6.38962 0.96967 6.53027C1.11032 6.67092 1.30109 6.74994 1.5 6.74994Z'
        fill='white'
      />
      <path
        d='M16.4998 11.2501H10.8103L12.5301 9.53031C12.6667 9.38886 12.7423 9.19941 12.7406 9.00276C12.7389 8.80611 12.66 8.618 12.521 8.47895C12.3819 8.33989 12.1938 8.26101 11.9971 8.25931C11.8005 8.2576 11.611 8.33319 11.4696 8.46981L8.46959 11.4698C8.32899 11.6105 8.25 11.8012 8.25 12.0001C8.25 12.1989 8.32899 12.3897 8.46959 12.5303L11.4696 15.5303C11.611 15.6669 11.8005 15.7425 11.9971 15.7408C12.1938 15.7391 12.3819 15.6602 12.521 15.5212C12.66 15.3821 12.7389 15.194 12.7406 14.9974C12.7423 14.8007 12.6667 14.6113 12.5301 14.4698L10.8103 12.7501H16.4998C16.6988 12.7501 16.8895 12.671 17.0302 12.5304C17.1708 12.3897 17.2498 12.199 17.2498 12.0001C17.2498 11.8011 17.1708 11.6104 17.0302 11.4697C16.8895 11.3291 16.6988 11.2501 16.4998 11.2501Z'
        fill='white'
      />
    </svg>
  )
}

export const IconRating = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3726_6762)'>
        <path
          d='M9.97131 17.4743L7.98898 22.8247L6.86142 21.2176C6.817 21.1543 6.75409 21.1063 6.68132 21.0801C6.60855 21.0539 6.52947 21.0509 6.45492 21.0715L4.54331 21.5978L6.67451 15.8455C6.56507 15.6521 6.47293 15.4494 6.39917 15.2398C6.3858 15.2043 6.36968 15.161 6.35357 15.1199C6.28827 15.1069 6.2227 15.0951 6.15724 15.0829L3.58584 22.0232C3.56188 22.0879 3.55623 22.158 3.56952 22.2257C3.58281 22.2934 3.61452 22.3561 3.66117 22.407C3.70781 22.4578 3.76758 22.4948 3.83389 22.5139C3.9002 22.533 3.97049 22.5334 4.03701 22.5151L6.39926 21.8647L7.78546 23.8404C7.82475 23.8963 7.87859 23.9405 7.94117 23.9681C8.00375 23.9957 8.07268 24.0056 8.14051 23.9968C8.20833 23.9881 8.27246 23.9609 8.32597 23.9183C8.37948 23.8757 8.42033 23.8193 8.44409 23.7552L10.7171 17.6203C10.6027 17.6262 10.488 17.6198 10.3749 17.6013C10.2355 17.5765 10.0998 17.5338 9.97131 17.4743Z'
          fill='black'
        />
        <path
          d='M17.8426 15.083C17.7771 15.0952 17.7114 15.107 17.6461 15.1201C17.6299 15.1611 17.6138 15.2043 17.6005 15.2398C17.5267 15.4494 17.4347 15.6521 17.3253 15.8454L19.4565 21.5978L17.5449 21.0714C17.4703 21.051 17.3913 21.054 17.3185 21.0802C17.2458 21.1063 17.1829 21.1543 17.1384 21.2176L16.0108 22.8247L14.0285 17.4742C13.8999 17.5338 13.7642 17.5765 13.6247 17.6013C13.5331 17.6172 13.4404 17.6252 13.3475 17.6251C13.3256 17.6251 13.3048 17.6224 13.2832 17.6216L15.5557 23.7552C15.5795 23.8193 15.6203 23.8757 15.6738 23.9183C15.7274 23.9609 15.7915 23.988 15.8593 23.9968C15.9271 24.0056 15.9961 23.9956 16.0586 23.9681C16.1212 23.9405 16.1751 23.8963 16.2144 23.8404L17.6006 21.8647L19.9628 22.5151C20.0293 22.5334 20.0996 22.533 20.1659 22.5139C20.2322 22.4948 20.292 22.4578 20.3386 22.407C20.3853 22.3561 20.417 22.2934 20.4303 22.2257C20.4436 22.158 20.4379 22.0879 20.414 22.0232L17.8426 15.083Z'
          fill='black'
        />
        <path
          d='M13.4967 16.862C13.8561 16.7984 14.1196 16.5127 14.353 16.2417C14.4554 16.0998 14.5843 15.979 14.7326 15.8862C14.9115 15.861 15.0936 15.8709 15.2688 15.9153C15.6047 15.9707 15.9858 16.0337 16.3123 15.8464C16.6428 15.6569 16.7788 15.2951 16.8986 14.9759C16.9461 14.8064 17.0264 14.6477 17.1349 14.509C17.2931 14.4259 17.466 14.3743 17.6439 14.3572C17.9802 14.2955 18.3615 14.2257 18.606 13.937C18.8509 13.6481 18.8546 13.263 18.8578 12.9232C18.8441 12.7469 18.8654 12.5696 18.9204 12.4015C19.0396 12.2718 19.1828 12.1664 19.342 12.0911C19.6387 11.9184 19.975 11.7226 20.1066 11.3647C20.2361 11.0118 20.1068 10.6503 19.9928 10.3313C19.9182 10.1688 19.8765 9.99305 19.8703 9.81432C19.9368 9.65514 20.0335 9.51026 20.1548 9.38759C20.3752 9.12292 20.625 8.82281 20.625 8.43747C20.625 8.05213 20.3752 7.75202 20.1548 7.48734C20.0334 7.36463 19.9368 7.21973 19.8701 7.06053C19.8765 6.88179 19.9182 6.70609 19.9927 6.54353C20.1067 6.22456 20.2361 5.86312 20.1065 5.51018C19.975 5.1523 19.6386 4.95657 19.3419 4.78381C19.1827 4.70856 19.0396 4.60327 18.9204 4.47372C18.8655 4.30559 18.8442 4.1283 18.8579 3.95196C18.8547 3.61221 18.851 3.22705 18.6061 2.93802C18.3616 2.64945 17.9803 2.5795 17.6441 2.5178C17.4661 2.50069 17.2932 2.44913 17.135 2.366C17.0265 2.22733 16.9463 2.06873 16.8988 1.89918C16.7789 1.58003 16.643 1.21822 16.3124 1.02862C15.986 0.84121 15.6051 0.904291 15.2689 0.95977C15.0937 1.00419 14.9116 1.01405 14.7327 0.988792C14.5843 0.895929 14.4554 0.775204 14.353 0.633292C14.1291 0.37319 13.8754 0.078391 13.4968 0.0126573C13.1294 -0.0511546 12.7953 0.136344 12.5009 0.301687C12.3496 0.404672 12.1793 0.476616 12 0.513355C11.8207 0.476616 11.6504 0.404672 11.4991 0.301687C11.2047 0.136435 10.8719 -0.050789 10.5033 0.0126573C10.1246 0.078391 9.87094 0.37319 9.647 0.633282C9.54461 0.775167 9.41571 0.895888 9.26743 0.988782C9.0885 1.01428 8.90631 1.00439 8.7312 0.959669C8.3952 0.90428 8.01435 0.841201 7.68769 1.02852C7.35718 1.21803 7.22122 1.57984 7.10137 1.899C7.05387 2.06858 6.97359 2.22721 6.86508 2.36591C6.70688 2.44904 6.53402 2.5006 6.35613 2.51771C6.01977 2.57941 5.63854 2.64927 5.39401 2.93793C5.1491 3.22687 5.14544 3.61194 5.14224 3.95169C5.1559 4.12803 5.13462 4.30534 5.07961 4.47345C4.96041 4.60312 4.81724 4.70851 4.65801 4.78381C4.36129 4.95657 4.02501 5.1523 3.89345 5.51027C3.7639 5.86311 3.89318 6.22465 4.00725 6.54362C4.08185 6.70617 4.12348 6.88188 4.12975 7.06062C4.06315 7.2198 3.96655 7.36467 3.8452 7.48734C3.62485 7.75202 3.375 8.05214 3.375 8.43747C3.375 8.8228 3.62485 9.12292 3.84521 9.3876C3.96657 9.51031 4.06321 9.65521 4.12985 9.81441C4.1235 9.99315 4.08184 10.1689 4.00726 10.3314C3.89328 10.6504 3.76392 11.0118 3.89346 11.3648C4.02503 11.7226 4.36139 11.9184 4.65811 12.0911C4.81728 12.1664 4.9604 12.2717 5.07961 12.4012C5.13452 12.5693 5.15577 12.7466 5.14214 12.923C5.14535 13.2627 5.14901 13.6479 5.39391 13.9369C5.63845 14.2255 6.01968 14.2954 6.35595 14.3571C6.53387 14.3743 6.70675 14.4258 6.86498 14.5089C6.97347 14.6476 7.05371 14.8062 7.10119 14.9758C7.22112 15.2949 7.35699 15.6567 7.68758 15.8463C8.01406 16.0337 8.39492 15.9707 8.7311 15.9152C8.90623 15.8706 9.0884 15.8607 9.26732 15.8862C9.41566 15.979 9.54459 16.0997 9.64699 16.2417C9.87093 16.5018 10.1246 16.7965 10.5032 16.8623C10.8704 16.9254 11.2046 16.7386 11.4991 16.5732C11.6504 16.4703 11.8207 16.3983 12 16.3616C12.1793 16.3983 12.3496 16.4703 12.5009 16.5733C12.8026 16.7427 13.138 16.9254 13.4967 16.862ZM12.868 15.9193C12.6097 15.7444 12.3109 15.6384 12 15.6116C11.6891 15.6384 11.3903 15.7444 11.132 15.9193C10.9557 16.0184 10.7377 16.1423 10.6315 16.1233C10.5178 16.1036 10.3501 15.9089 10.2155 15.7524C10.037 15.5057 9.79823 15.3089 9.52204 15.1807C9.22302 15.1014 8.90875 15.0995 8.6088 15.1752C8.40692 15.2087 8.15542 15.2501 8.06067 15.1958C7.96417 15.1405 7.875 14.9029 7.80332 14.7121C7.72021 14.4171 7.56231 14.1486 7.34491 13.9325C7.09168 13.7572 6.79784 13.6494 6.49127 13.6194C6.28903 13.5823 6.03745 13.5362 5.96613 13.4521C5.89646 13.3697 5.89408 13.1182 5.89215 12.9159C5.91531 12.6091 5.85854 12.3015 5.72736 12.0232C5.55015 11.7738 5.3119 11.574 5.0354 11.4429C4.85733 11.3393 4.63577 11.2103 4.59751 11.1062C4.56171 11.0085 4.64584 10.7732 4.7135 10.584C4.84203 10.3024 4.8954 9.99232 4.86841 9.68396C4.78886 9.39105 4.63496 9.12367 4.42163 8.90777C4.28952 8.74902 4.125 8.55145 4.125 8.43747C4.125 8.32349 4.28952 8.12592 4.42163 7.96717C4.63495 7.75127 4.78886 7.48389 4.8684 7.19099C4.89536 6.88266 4.84199 6.5726 4.71349 6.29103C4.64584 6.10188 4.56161 5.8665 4.5975 5.76891C4.63577 5.66463 4.85732 5.53563 5.0354 5.432C5.3119 5.30089 5.55015 5.10104 5.72735 4.85156C5.85861 4.57325 5.91542 4.26566 5.89224 3.95883C5.89416 3.75659 5.89654 3.50501 5.96621 3.42279C6.03753 3.33866 6.28921 3.29251 6.49145 3.25544C6.79799 3.22547 7.09179 3.11769 7.345 2.94233C7.56236 2.72625 7.72028 2.45774 7.8035 2.16276C7.87518 1.97197 7.96435 1.73439 8.06085 1.67909C8.15543 1.62462 8.40674 1.66628 8.60889 1.69969C8.90881 1.7753 9.22303 1.77345 9.52203 1.69429C9.79822 1.56604 10.037 1.36921 10.2155 1.12255C10.3501 0.966084 10.5178 0.771359 10.6316 0.751672C10.7348 0.732995 10.9555 0.856591 11.132 0.955649C11.3903 1.13059 11.6891 1.23652 12 1.26335C12.3109 1.23652 12.6097 1.13059 12.868 0.955638C13.0444 0.85667 13.2626 0.73225 13.3685 0.75166C13.4822 0.771348 13.6499 0.966076 13.7845 1.12254C13.963 1.3692 14.2018 1.56603 14.478 1.69428C14.777 1.77337 15.0912 1.77526 15.3912 1.69977C15.5931 1.66617 15.8445 1.6247 15.9393 1.67917C16.0358 1.73447 16.125 1.97205 16.1967 2.16284C16.2798 2.45785 16.4377 2.72638 16.6551 2.94241C16.9083 3.11778 17.2022 3.22555 17.5087 3.25552C17.711 3.2926 17.9626 3.33874 18.0339 3.42288C18.1035 3.50519 18.1059 3.75677 18.1078 3.95901C18.0847 4.26582 18.1415 4.5734 18.2726 4.85173C18.4499 5.10116 18.6881 5.30095 18.9646 5.43199C19.1427 5.53562 19.3642 5.66462 19.4025 5.76872C19.4383 5.86641 19.3542 6.10178 19.2865 6.29093C19.158 6.57253 19.1046 6.88262 19.1316 7.19098C19.2111 7.48389 19.365 7.75126 19.5784 7.96716C19.7105 8.12591 19.875 8.32348 19.875 8.43746C19.875 8.55145 19.7105 8.74901 19.5784 8.90777C19.365 9.12367 19.2111 9.39104 19.1316 9.68395C19.1046 9.99228 19.158 10.3023 19.2865 10.5839C19.3542 10.7731 19.4384 11.0084 19.4025 11.106C19.3642 11.2103 19.1427 11.3393 18.9646 11.4429C18.6881 11.574 18.4498 11.7739 18.2726 12.0234C18.1414 12.3017 18.0846 12.6093 18.1078 12.9161C18.1058 13.1184 18.1035 13.3699 18.0338 13.4522C17.9625 13.5363 17.7108 13.5824 17.5085 13.6195C17.202 13.6495 16.9082 13.7572 16.655 13.9326C16.4376 14.1487 16.2797 14.4172 16.1965 14.7122C16.1248 14.903 16.0356 15.1406 15.9391 15.1959C15.8443 15.2502 15.593 15.2085 15.3911 15.1753C15.0912 15.0996 14.777 15.1015 14.478 15.1807C14.2018 15.3089 13.963 15.5057 13.7845 15.7524C13.6499 15.9089 13.4822 16.1036 13.3684 16.1233C13.2658 16.142 13.0445 16.0184 12.868 15.9193Z'
          fill='black'
        />
        <path
          d='M17.25 8.43753C17.25 7.39918 16.9421 6.38414 16.3652 5.52078C15.7884 4.65742 14.9684 3.98451 14.0091 3.58714C13.0498 3.18978 11.9942 3.08581 10.9758 3.28838C9.95739 3.49095 9.02193 3.99096 8.2877 4.72518C7.55347 5.45941 7.05346 6.39487 6.85088 7.41327C6.64831 8.43167 6.75227 9.48727 7.14963 10.4466C7.54699 11.4059 8.2199 12.2258 9.08326 12.8027C9.94661 13.3796 10.9616 13.6875 12 13.6875C13.3919 13.6859 14.7264 13.1323 15.7106 12.1481C16.6948 11.1639 17.2484 9.82944 17.25 8.43753ZM12 12.9375C11.11 12.9375 10.24 12.6736 9.49996 12.1791C8.75995 11.6847 8.18318 10.9818 7.84259 10.1596C7.502 9.33732 7.41289 8.43253 7.58653 7.55963C7.76016 6.68672 8.18874 5.8849 8.81808 5.25557C9.44741 4.62624 10.2492 4.19766 11.1221 4.02403C11.995 3.8504 12.8998 3.93952 13.7221 4.28011C14.5444 4.6207 15.2472 5.19747 15.7416 5.93749C16.2361 6.6775 16.5 7.54752 16.5 8.43753C16.4987 9.6306 16.0241 10.7744 15.1805 11.618C14.3369 12.4617 13.1931 12.9362 12 12.9375Z'
          fill='black'
        />
        <path
          d='M15.1696 7.51564C15.148 7.44866 15.1081 7.38909 15.0543 7.34373C15.0005 7.29836 14.9351 7.26904 14.8654 7.25911L13.1161 7.00963L12.335 5.45654C12.3038 5.39445 12.256 5.34226 12.1968 5.30579C12.1376 5.26931 12.0695 5.25 12 5.25C11.9305 5.25 11.8624 5.26931 11.8033 5.30579C11.7441 5.34226 11.6962 5.39445 11.665 5.45654L10.8839 7.00963L9.13461 7.25911C9.06495 7.26903 8.99948 7.29835 8.9457 7.34372C8.89191 7.38909 8.85198 7.44868 8.83046 7.51567C8.80894 7.58267 8.80671 7.65436 8.82402 7.72257C8.84133 7.79077 8.87748 7.85273 8.92834 7.90135L10.1899 9.10819L9.89239 10.8104C9.88035 10.8792 9.88777 10.95 9.9138 11.0148C9.93982 11.0796 9.98343 11.1358 10.0397 11.1772C10.096 11.2185 10.1627 11.2434 10.2323 11.2488C10.3019 11.2543 10.3717 11.2403 10.4337 11.2082L12 10.4001L13.5663 11.2082C13.6286 11.2395 13.6982 11.2531 13.7677 11.2477C13.8371 11.2422 13.9038 11.2178 13.9603 11.1772C14.0166 11.1358 14.0602 11.0796 14.0862 11.0148C14.1122 10.95 14.1197 10.8792 14.1077 10.8104L13.8101 9.1082L15.0717 7.90135C15.1225 7.85271 15.1587 7.79074 15.176 7.72254C15.1933 7.65434 15.1911 7.58264 15.1696 7.51564ZM13.1471 8.70454C13.1026 8.74711 13.0692 8.79999 13.05 8.85852C13.0308 8.91704 13.0263 8.9794 13.0369 9.04008L13.2387 10.1953L12.172 9.64487C12.1185 9.61845 12.0597 9.6047 12 9.6047C11.9404 9.6047 11.8815 9.61845 11.8281 9.64487L10.7613 10.1953L10.9632 9.04008C10.9738 8.9794 10.9693 8.91704 10.9501 8.85852C10.9308 8.79999 10.8975 8.74711 10.853 8.70454L10.0043 7.89266L11.1838 7.72447C11.2437 7.71594 11.3007 7.69304 11.3498 7.65772C11.3989 7.62241 11.4387 7.57573 11.4659 7.52168L12 6.45968L12.5341 7.52168C12.5613 7.57574 12.6011 7.62241 12.6503 7.65773C12.6994 7.69304 12.7563 7.71594 12.8162 7.72447L13.9958 7.89266L13.1471 8.70454Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_3726_6762'>
          <rect width={24} height={24} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const FreeShip = ({ className }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={21}
      height={21}
      viewBox='0 0 21 21'
      fill='none'
      className={className}
    >
      <mask
        id='mask0_8_2739'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={21}
        height={21}
      >
        <path
          d='M0.867188 0.304688H20.8672V20.3047H0.867188V0.304688Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_8_2739)'>
        <path
          d='M18.34 5.43524C19.5382 5.31356 20.4733 4.30157 20.4733 3.07121C20.4733 1.75879 19.4094 0.694886 18.097 0.694886C16.7846 0.694886 15.7207 1.75879 15.7207 3.07121C15.7207 3.72739 15.9866 4.32145 16.4166 4.75145'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.98043 12.8742L5.04004 13.8146L7.36023 16.1348'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.17773 14.9521L7.0434 14.0864'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.78516 12.4946L10.8672 12.6274'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.29199 11.5618L9.61219 13.882'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.14965 10.9106C9.48266 11.2436 9.46063 11.8056 9.11551 12.1507C8.94438 12.3218 8.50594 12.7656 8.50594 12.7656C8.50594 12.7656 8.06539 12.3306 7.8975 12.1627C7.75965 12.0248 7.29297 11.5613 7.29297 11.5613C7.29297 11.5613 7.7073 11.147 7.90953 10.9447C8.25465 10.5996 8.81664 10.5776 9.14965 10.9106Z'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.0528 5.80108L12.0752 6.7787L14.3954 9.09889L15.373 8.12127'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.1409 7.03329L13.2354 7.93884'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.7872 8.0667L9.80957 9.04432L12.1298 11.3645L13.1074 10.3869'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.8753 9.29891L10.9697 10.2045'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.6147 13.9493L17.8405 10.7234C18.1335 10.4304 18.2981 10.033 18.2981 9.6186V4.44048C18.2981 3.57755 17.5986 2.87798 16.7356 2.87798H11.555C11.1407 2.87798 10.7433 3.04255 10.4503 3.33552L1.71754 12.0662C1.10723 12.6763 1.10715 13.6658 1.71743 14.276L6.89782 19.4564C7.50801 20.0666 8.49735 20.0666 9.10754 19.4564L12.1288 16.4352'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}
export const IconInstallment = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={36}
      height={36}
      viewBox='0 0 44 44'
      fill='none'
    >
      <path
        d='M21.6171 43.2826C33.4749 43.2826 43.0876 33.6699 43.0876 21.812C43.0876 9.95414 33.4749 0.341431 21.6171 0.341431C9.75919 0.341431 0.146484 9.95414 0.146484 21.812C0.146484 33.6699 9.75919 43.2826 21.6171 43.2826Z'
        fill='#FFD112'
      />
      <path
        d='M39.9238 10.4326C36.1059 16.4913 29.3337 20.5171 21.6172 20.5171C13.9006 20.5171 7.12838 16.4913 3.31055 10.4326C7.12163 4.37388 13.9006 0.341431 21.6172 0.341431C29.3337 0.341431 36.1127 4.37388 39.9238 10.4326Z'
        fill='#FFE955'
      />
      <g opacity='0.1'>
        <path
          d='M35.0146 37.8361C35.0146 38.3119 29.015 38.6979 21.6167 38.6979C14.2183 38.6979 8.21875 38.3119 8.21875 37.8361C8.21875 37.3602 14.2183 36.9795 21.6167 36.9795C29.015 36.9795 35.0146 37.3602 35.0146 37.8361Z'
          fill='black'
        />
      </g>
      <path
        d='M21.6187 33.3718C27.946 33.3718 33.0752 28.2426 33.0752 21.9153C33.0752 15.588 27.946 10.4587 21.6187 10.4587C15.2914 10.4587 10.1621 15.588 10.1621 21.9153C10.1621 28.2426 15.2914 33.3718 21.6187 33.3718Z'
        fill='white'
      />
      <path
        d='M27.7657 22.1497H21.6184C21.4886 22.1497 21.3838 22.0449 21.3838 21.9152C21.3838 21.7854 21.4886 21.6806 21.6184 21.6806H27.7657C27.8955 21.6806 28.0003 21.7854 28.0003 21.9152C28.0003 22.0449 27.8955 22.1497 27.7657 22.1497Z'
        fill='#FF3445'
      />
      <path
        d='M21.7537 22.2514L16.3754 27.6255C16.2346 27.7663 16.0043 27.7663 15.8635 27.6255C15.791 27.553 15.7568 27.4634 15.7568 27.3696C15.7568 27.2757 15.791 27.1862 15.8635 27.1136L21.2419 21.7395C21.3784 21.5987 21.6087 21.5987 21.7495 21.7395C21.8902 21.8803 21.8945 22.1106 21.7537 22.2514Z'
        fill='#20273A'
      />
      <path
        d='M17.5205 15.0516C17.4392 15.0516 17.3606 15.0097 17.3173 14.9343L16.516 13.5466C16.4511 13.4345 16.4891 13.291 16.6018 13.2262C16.7132 13.16 16.858 13.1999 16.9222 13.312L17.7236 14.6998C17.7885 14.8118 17.7505 14.9553 17.6378 15.0202C17.6011 15.0418 17.5604 15.0516 17.5205 15.0516Z'
        fill='#20273A'
      />
      <path
        d='M26.5175 30.6349C26.4369 30.6349 26.3577 30.593 26.3144 30.5176L25.5131 29.1305C25.4482 29.0185 25.4862 28.875 25.5989 28.8101C25.7096 28.7446 25.8544 28.7832 25.9193 28.8959L26.7207 30.2831C26.7855 30.3951 26.7475 30.5386 26.6348 30.6035C26.5981 30.6251 26.5575 30.6349 26.5175 30.6349Z'
        fill='#20273A'
      />
      <path
        d='M14.52 18.0513C14.48 18.0513 14.4394 18.0415 14.4027 18.0198L13.0149 17.2191C12.9022 17.1549 12.8642 17.0108 12.9291 16.8987C12.9933 16.7867 13.1381 16.7474 13.2495 16.8129L14.6373 17.6136C14.75 17.6778 14.788 17.822 14.7231 17.934C14.6799 18.0093 14.6012 18.0513 14.52 18.0513Z'
        fill='#20273A'
      />
      <path
        d='M30.104 27.0489C30.064 27.0489 30.0234 27.0391 29.9867 27.0174L28.5989 26.2161C28.4862 26.1512 28.4482 26.0077 28.5131 25.8957C28.5779 25.783 28.7221 25.7443 28.8335 25.8098L30.2213 26.6112C30.334 26.6761 30.372 26.8195 30.3071 26.9316C30.2638 27.0069 30.1852 27.0489 30.104 27.0489Z'
        fill='#20273A'
      />
      <path
        d='M13.4225 22.1497H11.8205C11.6908 22.1497 11.5859 22.0449 11.5859 21.9152C11.5859 21.7854 11.6908 21.6806 11.8205 21.6806H13.4225C13.5523 21.6806 13.6571 21.7854 13.6571 21.9152C13.6571 22.0449 13.5523 22.1497 13.4225 22.1497Z'
        fill='#20273A'
      />
      <path
        d='M31.4167 22.1498H29.8147C29.6849 22.1498 29.5801 22.0449 29.5801 21.9152C29.5801 21.7855 29.6849 21.6806 29.8147 21.6806H31.4167C31.5464 21.6806 31.6513 21.7855 31.6513 21.9152C31.6513 22.0449 31.5464 22.1498 31.4167 22.1498Z'
        fill='#20273A'
      />
      <path
        d='M13.1322 27.0489C13.051 27.0489 12.9723 27.007 12.9291 26.9317C12.8642 26.8196 12.9022 26.6761 13.0149 26.6112L14.4027 25.8099C14.5141 25.7444 14.6582 25.783 14.7231 25.8957C14.788 26.0078 14.75 26.1513 14.6373 26.2161L13.2495 27.0175C13.2128 27.0391 13.1722 27.0489 13.1322 27.0489Z'
        fill='#20273A'
      />
      <path
        d='M28.7162 18.0513C28.6349 18.0513 28.5563 18.0094 28.5131 17.934C28.4482 17.822 28.4862 17.6778 28.5989 17.6136L29.9867 16.8129C30.0981 16.7474 30.2429 16.7867 30.3071 16.8988C30.372 17.0108 30.334 17.155 30.2213 17.2192L28.8335 18.0199C28.7968 18.0415 28.7562 18.0513 28.7162 18.0513Z'
        fill='#20273A'
      />
      <path
        d='M16.7191 30.6349C16.6792 30.6349 16.6385 30.6251 16.6018 30.6035C16.4891 30.5386 16.4511 30.3951 16.516 30.2831L17.3173 28.8959C17.3822 28.7832 17.5264 28.7446 17.6378 28.8101C17.7505 28.875 17.7885 29.0185 17.7236 29.1305L16.9222 30.5176C16.879 30.593 16.7997 30.6349 16.7191 30.6349Z'
        fill='#20273A'
      />
      <path
        d='M25.7162 15.0516C25.6762 15.0516 25.6356 15.0418 25.5989 15.0201C25.4862 14.9553 25.4482 14.8118 25.5131 14.6997L26.3144 13.312C26.3786 13.1999 26.5234 13.1599 26.6348 13.2261C26.7475 13.291 26.7855 13.4345 26.7207 13.5465L25.9193 14.9343C25.8761 15.0097 25.7974 15.0516 25.7162 15.0516Z'
        fill='#20273A'
      />
      <path
        d='M21.6184 31.9481C21.4886 31.9481 21.3838 31.8432 21.3838 31.7135V30.1108C21.3838 29.9811 21.4886 29.8762 21.6184 29.8762C21.7481 29.8762 21.8529 29.9811 21.8529 30.1108V31.7135C21.8529 31.8432 21.7481 31.9481 21.6184 31.9481Z'
        fill='#20273A'
      />
      <path
        d='M22.074 15.6949V22.5879H21.1621V15.6949C21.1621 15.4458 21.369 15.2432 21.6181 15.2432C21.8671 15.2432 22.074 15.4458 22.074 15.6949Z'
        fill='#20273A'
      />
      <path
        d='M21.619 23.2921C22.3794 23.2921 22.9958 22.6756 22.9958 21.9153C22.9958 21.1549 22.3794 20.5385 21.619 20.5385C20.8586 20.5385 20.2422 21.1549 20.2422 21.9153C20.2422 22.6756 20.8586 23.2921 21.619 23.2921Z'
        fill='#20273A'
      />
      <path
        d='M21.6187 22.5144C21.9496 22.5144 22.2179 22.2461 22.2179 21.9152C22.2179 21.5843 21.9496 21.3161 21.6187 21.3161C21.2878 21.3161 21.0195 21.5843 21.0195 21.9152C21.0195 22.2461 21.2878 22.5144 21.6187 22.5144Z'
        fill='white'
      />
      <path
        d='M35.9597 21.9118C35.9597 29.829 29.5387 36.2567 21.6148 36.2567C13.6907 36.2567 7.27637 29.829 7.27637 21.9118C7.27637 17.1681 9.5845 12.9544 13.1405 10.3445L14.9454 12.6055C12.0469 14.6788 10.1615 18.0738 10.1615 21.9118C10.1615 28.2388 15.2876 33.3717 21.6148 33.3717C27.9486 33.3717 33.0746 28.2388 33.0746 21.9118C33.0746 16.7521 29.6662 12.3909 24.9695 10.9617C23.9094 10.633 22.7822 10.4585 21.6148 10.4585V12.7867C21.6148 13.2765 21.0645 13.5516 20.6686 13.2698L15.5627 9.57279C15.234 9.33134 15.234 8.84148 15.5627 8.59994L20.6686 4.88954C21.0645 4.60779 21.6148 4.88954 21.6148 5.37261V7.57336C22.7688 7.57336 23.896 7.7076 24.9695 7.96928C31.2765 9.47893 35.9597 15.1485 35.9597 21.9118Z'
        fill='#1076E5'
      />
    </svg>
  )
}
export const IconBNPL = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={38}
      height={38}
      viewBox='0 0 38 38'
      fill='none'
    >
      <path
        d='M36.3483 31.7285C36.3268 31.7285 25.3808 36.1861 23.4701 36.946C23.2963 37.0113 23.2095 37.0545 23.188 37.0545C20.7564 38.1618 17.5652 38.14 14.96 36.8159L5.0166 32.8573V21.1124L11.2257 20.2004C12.333 19.8965 13.3967 20.0051 14.3519 20.4828C14.569 20.5914 22.8406 24.7378 23.3616 24.9984C23.4051 25.0202 23.4483 25.0419 23.4701 25.0637C24.4471 25.5847 24.838 26.8437 24.3167 27.9075C24.1214 28.2984 23.8175 28.6241 23.4701 28.8194C22.8623 29.1668 22.1025 29.2101 21.4077 28.863C21.1908 28.7544 17.3695 26.8655 17.3695 26.8655C16.0019 26.1924 14.3519 26.5616 13.3967 27.7557C13.0058 28.2331 13.0928 28.9062 13.5703 29.2754C14.0265 29.6443 14.7211 29.5793 15.09 29.1015C15.4156 28.7109 15.9584 28.5806 16.4361 28.7977L20.4307 30.8166C21.0602 31.1205 21.7333 31.2725 22.3846 31.2725C22.5149 31.2725 22.9056 31.1858 23.4701 31.034C26.5313 30.2306 34.7636 27.7122 34.7636 27.7122C35.8708 27.3432 37.0214 27.9075 37.4556 28.9062C37.9333 29.7096 37.5426 31.2072 36.3483 31.7285Z'
        fill='#FFCEBF'
      />
      <path
        d='M36.3489 31.7285C36.3274 31.7285 25.3814 36.1861 23.4707 36.946V31.0337C26.5319 30.2306 34.7642 27.7122 34.7642 27.7122C35.8714 27.343 37.0219 27.9075 37.4561 28.9062C37.9339 29.7096 37.5432 31.2073 36.3489 31.7285Z'
        fill='#FFBFAB'
      />
      <path
        d='M23.4707 0.806152C18.0867 0.806152 13.7012 5.26406 13.7012 10.648C13.7012 16.032 18.0867 20.4175 23.4707 20.4175C28.8547 20.4175 33.2402 16.032 33.2402 10.648C33.2402 5.26406 28.8547 0.806152 23.4707 0.806152Z'
        fill='#FFE470'
      />
      <path
        d='M23.4707 20.4175V0.806152C28.8547 0.806152 33.2402 5.26406 33.2402 10.648C33.2402 16.032 28.8547 20.4175 23.4707 20.4175Z'
        fill='#FFD400'
      />
      <path
        d='M23.4706 2.97716C19.2807 2.97716 15.8721 6.45811 15.8721 10.648C15.8721 14.838 19.2807 18.2465 23.4706 18.2465C27.6605 18.2465 31.0691 14.838 31.0691 10.648C31.0691 6.45811 27.6605 2.97716 23.4706 2.97716Z'
        fill='#FDBF00'
      />
      <path
        d='M31.0692 10.648C31.0692 14.838 27.6606 18.2465 23.4707 18.2465V2.97716C27.6606 2.97716 31.0692 6.45811 31.0692 10.648Z'
        fill='#FF9F00'
      />
      <path
        d='M26.7269 12.819C26.7269 14.2302 25.8152 15.4242 24.5559 15.8802V17.161C24.5559 17.7691 24.0784 18.2465 23.4704 18.2465C22.8623 18.2465 22.3849 17.7691 22.3849 17.161V15.8802C21.1255 15.4242 20.2139 14.2302 20.2139 12.819C20.2139 12.211 20.6913 11.7335 21.2994 11.7335C21.9074 11.7335 22.3849 12.211 22.3849 12.819C22.3849 13.4271 22.8623 13.9045 23.4704 13.9045C24.0784 13.9045 24.5559 13.4271 24.5559 12.819C24.5559 12.211 24.0784 11.7335 23.4704 11.7335C21.6683 11.7335 20.2139 10.2791 20.2139 8.47703C20.2139 7.06588 21.1255 5.87183 22.3849 5.41614V4.06266C22.3849 3.45461 22.8623 2.97716 23.4704 2.97716C24.0784 2.97716 24.5559 3.45461 24.5559 4.06266V5.41614C25.8152 5.87183 26.7269 7.06588 26.7269 8.47703C26.7269 9.08508 26.2494 9.56253 25.6414 9.56253C25.0333 9.56253 24.5559 9.08508 24.5559 8.47703C24.5559 7.86898 24.0784 7.39153 23.4704 7.39153C22.8623 7.39153 22.3849 7.86898 22.3849 8.47703C22.3849 9.08508 22.8623 9.56253 23.4704 9.56253C25.2725 9.56253 26.7269 11.0169 26.7269 12.819Z'
        fill='#FFE470'
      />
      <path
        d='M6.10241 35.6869H1.68804C1.08847 35.6869 0.602539 35.201 0.602539 34.6014V19.332C0.602539 18.7325 1.08847 18.2465 1.68804 18.2465H3.93141C5.72983 18.2465 7.18791 19.7046 7.18791 21.503V34.6014C7.18791 35.201 6.70198 35.6869 6.10241 35.6869Z'
        fill='#FF4B00'
      />
      <path
        d='M26.7272 12.8191C26.7272 14.2302 25.8156 15.4243 24.5562 15.8802V17.1611C24.5562 17.7691 24.0788 18.2466 23.4707 18.2466V13.9046C24.0788 13.9046 24.5562 13.4271 24.5562 12.8191C24.5562 12.211 24.0788 11.7336 23.4707 11.7336V9.56256C25.2728 9.56256 26.7272 11.017 26.7272 12.8191Z'
        fill='#FFD400'
      />
      <path
        d='M23.4707 7.39153V2.97716C24.0788 2.97716 24.5562 3.45461 24.5562 4.06266V5.41614C25.8156 5.87183 26.7272 7.06588 26.7272 8.47703C26.7272 9.08508 26.2498 9.56253 25.6417 9.56253C25.0337 9.56253 24.5562 9.08508 24.5562 8.47703C24.5562 7.86898 24.0788 7.39153 23.4707 7.39153Z'
        fill='#FFD400'
      />
    </svg>
  )
}
